import { axios } from '@/services/axios';

export const updateTRSCluster = (clusterData) => {
    const res = axios.put('/TRSCluster', clusterData);
    return res;
};
